import { BREADCRUMB_ITEM_MAX_CHARS } from '../constants'

export const formatBreadcrumbSubstring = (text: string): string => {
  return text.length <= BREADCRUMB_ITEM_MAX_CHARS
    ? text
    : text.substr(0, BREADCRUMB_ITEM_MAX_CHARS - 1) + '...'
}
